var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("footer", { staticClass: "common-footer text-center mt-5" }, [
    _c("div", { staticClass: "container-xl" }, [
      _c(
        "div",
        {
          staticClass:
            "footer-navigation d-lg-flex align-items-start py-5 m-auto",
        },
        [
          _c(
            "div",
            { staticClass: "footer-brand mb-4 mb-lg-0 max-width-logo" },
            [
              _c("img", {
                staticClass: "footer-logo d-block mx-auto mb-1 mt-n6",
                attrs: {
                  width: "120",
                  src: "/media/logo-main-white.svg",
                  alt: _vm.T.frontPageFooterLogoAlt,
                },
              }),
              _c("div", { staticClass: "slogan mx-auto" }, [
                _vm._v(" " + _vm._s(_vm.T.frontPageFooter) + " "),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "footer-list-section footer-contact w-50 mb-4 mb-lg-0 mx-auto",
            },
            [
              _c("h4", { staticClass: "column-title" }, [
                _vm._v(_vm._s(_vm.T.frontPageFooterContact)),
              ]),
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass:
                    "social-icons my-0 mx-auto d-flex flex-md-column flex-sm-row justify-content-center flex-wrap",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "mx-1 pt-2",
                      attrs: {
                        href: "https://www.facebook.com/omegaup/",
                        target: "_blank",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fab", "facebook"] },
                      }),
                      _vm._v(" Facebook "),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "mx-1 pt-2",
                      attrs: {
                        href: "https://discord.gg/K3JFd9d3wk",
                        target: "_blank",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fab", "discord"] },
                      }),
                      _vm._v(" Discord "),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "mx-1 pt-2",
                      attrs: {
                        href: "https://www.instagram.com/omegaup_org/",
                        target: "_blank",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fab", "instagram"] },
                      }),
                      _vm._v(" Instagram "),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "footer-list-section footer-site w-50 mb-4 mb-lg-0 mx-auto",
            },
            [
              _c("h4", { staticClass: "column-title" }, [
                _vm._v(_vm._s(_vm.T.frontPageFooterSite)),
              ]),
              _c("ul", [
                _c("li", { staticClass: "mt-1" }, [
                  _c("a", { attrs: { href: "/arena/" } }, [
                    _vm._v(_vm._s(_vm.T.navContests)),
                  ]),
                ]),
                _c("li", { staticClass: "mt-1" }, [
                  _c("a", { attrs: { href: "/problem/" } }, [
                    _vm._v(_vm._s(_vm.T.navProblems)),
                  ]),
                ]),
                _c("li", { staticClass: "mt-1" }, [
                  _c("a", { attrs: { href: "/rank/" } }, [
                    _vm._v(_vm._s(_vm.T.navRanking)),
                  ]),
                ]),
                _c("li", { staticClass: "mt-1" }, [
                  _c("a", { attrs: { href: "/course/" } }, [
                    _vm._v(_vm._s(_vm.T.navCourses) + " "),
                  ]),
                ]),
                _c("li", { staticClass: "mt-1" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.OmegaUpBlogURL, target: "_blank" } },
                    [_vm._v(_vm._s(_vm.T.navBlog))]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "footer-list-section footer-sponsors w-50 mb-4 mb-lg-0 mx-auto",
            },
            [
              _c("h4", { staticClass: "column-title" }, [
                _vm._v(_vm._s(_vm.T.frontPageFooterSponsors)),
              ]),
              _vm._m(1),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "footer-list-section footer-organization d-inline-block w-50 mb-4",
            },
            [
              _c("h4", { staticClass: "column-title" }, [
                _vm._v(_vm._s(_vm.T.frontPageFooterOrganization)),
              ]),
              _c("ul", [
                _c("li", { staticClass: "mt-1" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://omegaup.org/#about",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.T.frontPageFooterAboutUs))]
                  ),
                ]),
                _c("li", { staticClass: "mt-1" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://omegaup.org/#team",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.T.frontPageFooterTeam))]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "footer-list-section footer-developers d-inline-block w-50 mb-4",
            },
            [
              _c("h4", { staticClass: "column-title" }, [
                _vm._v(_vm._s(_vm.T.frontPageDevelopers)),
              ]),
              _c("ul", [
                _c("li", { staticClass: "mt-1" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/omegaup/omegaup/blob/main/frontend/www/docs/Development-Environment-Setup-Process.md",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.T.frontPageFooterHelpUs))]
                  ),
                ]),
                _c("li", { staticClass: "mt-1" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/omegaup/omegaup",
                        target: "_blank",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fab", "github"] },
                      }),
                      _vm._v(" Github "),
                    ],
                    1
                  ),
                ]),
                _c("li", { staticClass: "mt-1" }, [
                  !_vm.omegaUpLockDown && _vm.isLoggedIn
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "https://github.com/omegaup/omegaup/issues/new",
                            target: "_blank",
                            rel: "nofollow",
                          },
                          on: {
                            click: function ($event) {
                              $event.target.href = _vm.reportAnIssueURL()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.T.reportAnIssue))]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "copy mt-3" }, [
      _c(
        "div",
        {
          staticClass:
            "container-xl d-md-flex justify-content-between align-items-center py-3",
        },
        [
          _c(
            "ul",
            {
              staticClass:
                "mb-2 m-md-0 list-unstyled d-flex justify-content-around d-md-inline-flex order-md-12",
            },
            [
              _c("li", { staticClass: "pr-2" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.CodeofConductPolicyURL,
                      target: "_blank",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.T.frontPageFooterCodeConduct) + " ")]
                ),
              ]),
              _c("li", [
                _c(
                  "a",
                  { attrs: { href: _vm.PrivacyPolicyURL, target: "_blank" } },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.T.frontPageFooterPrivacyPolicy) + " "
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _c("div", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.ui.formatString(_vm.T.frontPageFooterCopyright, {
                    currentYear: new Date().getFullYear(),
                  })
                ) +
                " "
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", { staticClass: "mt-1" }, [
        _c("a", { attrs: { href: "mailto:hello@omegaup.com" } }, [
          _vm._v("hello@omegaup.com"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", { staticClass: "mt-4" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://news.airbnb.com/2025-community-fund/",
              target: "_blank",
            },
          },
          [
            _c("img", {
              staticClass: "sponsor-logo",
              attrs: {
                src: "/media/homepage/airbnb_logo.svg",
                alt: "AirbnbLogo",
                width: "100",
              },
            }),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }